/**
 * @generated SignedSource<<78f996b5f36e727e446cbdf769ef2d08>>
 * @relayHash 5a2c88263fd15e365a2dc21afeac04c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d60296a2f3967eee8ead20ad2495ab7874f5ab64ecbe45fa7adef32797c49879

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { main_getIssueTransitionByIdRootQuery } from './main_getIssueTransitionByIdRootQuery.graphql';

import isLicenseCapabilitySetEnabled_provider from '@atlassian/jira-relay-provider/src/platform-forge-ui-license-capability-set.relayprovider';

const node: PreloadableConcreteRequest<main_getIssueTransitionByIdRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d60296a2f3967eee8ead20ad2495ab7874f5ab64ecbe45fa7adef32797c49879",
    "metadata": {},
    "name": "main_getIssueTransitionByIdRootQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcplatformforgeuilicensecapabilitysetrelayprovider": isLicenseCapabilitySetEnabled_provider
    }
  }
};

export default node;
